import React, { useEffect, useState } from "react";
import HeaderOS1 from "./HeaderOS1";
import "./FormularioStyle.css"
import { useSearchParams } from "react-router-dom";
import ServiceBackend from "../Services/ServiceBackend"
import configSecc from "../Services/config.json";
import CanvasDraw from "react-canvas-draw";
import { useRef } from "react";
import ModalStyles from "./ModalStyles.module.css";
import { Modal, ModalBody, ModalHeader, Label, ModalFooter, Button, Spinner} from "reactstrap";
import ModalFirmaData from "./Common/ModalFirmaData";
import ModalFirmaPie from "./Common/ModalFirmaPie";


const Vista = () => {

    
    const [modalFirmaOS, setModalFirmaOS] = useState(false);
    const [modalFirmaSIN, setModalFirmaSIN] = useState(false);

    const [dia, setDia] = useState(0);
    const [mes, setMes] = useState(0);
    const [anio, setAnio] = useState(0);
    const [delegacion, setDelegacion] = useState(0)
    const [datos, setDatos] = useState({});
    const [tipoForm, setTipoForm] = useState("");

    const [searchParams, setSearchParams] = useSearchParams();
    const [fileRecibo, setFileRecibo] = useState();
    const [fileAlta, setFileAlta] = useState();
    const [fileDNI, setFileDNI] = useState();
    const [fileDNI2, setFileDNI2] = useState();
    const [firmaLoading, setFirmaLoading] = useState(true);

    const firmaS = useRef(null);
    const firmaSIN = useRef(null);
    const [firmaStringOS, setFirmaStringOS] = useState("");
    const [firmaStringSIN, setFirmaStringSIN] = useState("");

    const [errors, setErrors] = useState([]);
    const [valid, setValid] = useState(false);
    const [loading, setLoading] = useState(true);
    const [familiares, setFamiliares] = useState({})


    const toggleModalFirmaOS = () =>{ setModalFirmaOS(!modalFirmaOS)}
    const toggleModalFirmaSIN = () => { setModalFirmaSIN(!modalFirmaSIN)}
    


    const fillFields = () => {
       
      let idSolUrl= searchParams.get("id");
      let tramite = searchParams.get("tramite");
        ServiceBackend.getData(idSolUrl, tramite)
            .then((resp)=>{
                setDatos(resp.data.solicitud)
                setFamiliares(resp.data)
                ServiceBackend.getFirma(idSolUrl).then((resf)=>{
                    setFirmaLoading(false)
                    firmaS.current.loadSaveData(resf.data.description,true);
                }
                    )
                setLoading(false)
            })
            .catch((error)=>{
                console.log(error);
                alert("Error consultando")
                setLoading(true)
            });
        setLoading(true)


    }

    const setCurrent = () =>{
        const now = new Date();
        setDia(now.getDate());
        setMes(now.getMonth()+1);
        setAnio(now.getFullYear());
    }
    
    const setTipoFormulario =() =>{
        let valUrl = datos.tipo;
        if (valUrl=="OS")
            setTipoForm("OS")
        else if (valUrl=="SIN")
            setTipoForm("SIN")
        else setTipoForm("OSSIN");
      
    }

   



  

    useEffect(()=>{
fillFields();
setCurrent();

    },[])

    
   
   
    return(
        <>
       
       <div className="container-fluid margin20 needs-validation">
       <h1 className="bd-content-title">
            Solicitud de alta en  {datos.tipo=="OS"?"Obra Social":"Sindicato"}
        </h1>
      
       
    

    <div className="row">


        <div className="col-sm-4 alignRight">  
        {dia}
         / {mes} / {anio}
    </div>
    </div>
    <div className="row">
        <div className="col-sm-6 form-group">
            <label  for="validationDefault01className" className="control-label">Seccional/Delegación: </label>
           
        <label> {datos.seccional} </label >
          
            
          
                
        </div>
        <div className="col-sm-6 form-group">
            <label className="control-label"> Nº trámite: </label>
            <label>{datos.nrotramite} </label>
            </div>
    </div>
    <div className="row">
        <div className="col-sm-10 form-group">
            <label className="control-label">Apellido y nombre: </label>
            <label>{datos.nombreapellido} </label>
                 
        </div>
    </div>
    <div className="row">
        <div className="col-sm-5 form-group">
            <label className="control-label">Domicilio: </label>
            <label>{datos.domicilio} </label>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">CP: </label>
            <label>{datos.cp} </label>
            </div>
            <div className="col-sm-4 form-group">
            <label className="control-label">Localidad: </label>
            <label>{datos.cp} </label>
            </div>
    </div>
    <div className="row">
        <div className="col-sm-4 form-group">
            <label className="control-label">Provincia: </label>
            <label>{datos.provincia} </label>
          
        </div>
        <div className="col-sm-4 form-group">
            <label className="control-label">Email: </label>
            <label>{datos.email} </label>
            </div>
            <div className="col-sm-4 form-group">
            <label className="control-label">Tel: </label>
            <label>{datos.tel} </label>
            </div>
    </div>
    <div className="row">
        <div className="col-sm-4 form-group">
            <label className="control-label">Fecha Nac. </label>
            <label>{!loading?datos.fechanac.substring(0,10):""} </label>
        </div>
        <div className="col-sm-2 form-group">
            <label className="control-label">Edad: </label>
            <label>{datos.edad} </label>
            </div>
            <div className="col-sm-2 form-group">
            <label className="control-label">Sexo: </label>

            <label>{datos.sexo} </label>
            
            </div>
            <div className="col-sm-4 form-group">
            <label className="control-label">Nacionalidad: </label>
            <label>{datos.nacionalidad} </label>
            </div>
    </div>

    <div className="row">
        <div className="col-sm-4 form-group">
            <label className="control-label">Estado Civil: </label>
            <label>{datos.estcivil} </label>
          
        </div>
        <div className="col-sm-4 form-group">
            <label className="control-label">CUIL Nº: </label>
            <label>{datos.cuil} </label>
            </div>
            <div className="col-sm-4 form-group">
            <label className="control-label">CEL: </label>
            <label>{datos.cel} </label>
            </div>
          
    </div>

    <h3 className="bd-content-title">
            Datos laborales: (donde presta servicio)
        </h3>


    <div className="row">
        <div className="col-sm-6 form-group">
            <label className="control-label">CUIT Nº:</label>
            <label>{datos.cuit} </label>
        </div>
        <div className="col-sm-6 form-group">
            <label className="control-label">Fecha de alta:</label>
            <label>{!loading?datos.fechaalta.substring(0,10):""} </label>
        </div>
    </div>
    <div className="row">
        <div className="col-sm-6 form-group">
            <label className="control-label">Razón Social:</label>
            <label>{datos.razonsocial} </label>
        </div>
        <div className="col-sm-6 form-group">
            <label className="control-label">Categoría laboral:</label>
            <label>{datos.categorialaboral} </label>
        </div>
    </div>
    <div className="row">
        <div className="col-sm-6 form-group">
            <label className="control-label">Direccion:</label>
            <label>{datos.direccionlaboral} </label>
        </div>
        <div className="col-sm-6 form-group">
            <label className="control-label">Localidad:</label>
            <label>{datos.localidadlaboral} </label>
        </div>
    </div>
    <div className="row">
        <div className="col-sm-6 form-group">
            <label className="control-label">Provincia:</label>
            <label>{datos.provincialaboral} </label>
            
        
        </div>
        <div className="col-sm-6 form-group">
            <label className="control-label">Telefono:</label>
            <label>{datos.telefonolaboral} </label>
        </div>
    </div>

    <div className="row">
        <div className="col-sm-6 form-group">
            <label className="control-label">Email:</label>
            <label>{datos.emaillaboral} </label>
        </div>
        <div className="col-sm-6 form-group">
            <label className="control-label">Página Web:</label>
            <label>{datos.paginaweblaboral} </label>
        </div>
    </div>

    <h3>
            Declaración jurada familiares a cargo:
        </h3>
{ !loading?
    familiares.familiares.map(x =>{
        return(
            <div className="row">
            <div className="col-sm-4 form-group">
                <label className="control-label">Apellido y nombre:</label>
                <label>{x.apellido_nombre} </label>
            </div>
            <div className="col-sm-2 form-group">
                <label className="control-label">Parentesco:</label>
                <label>{x.parentesco} </label>
            </div>
            <div className="col-sm-3 form-group">
                <label className="control-label">DNI:</label>
                <label>{x.cuil} </label>
            </div>
            <div className="col-sm-3 form-group">
                <label className="control-label">Fec Nac:</label>
                <label>{!loading?x.fecha_nac.substring(0,10):""} </label>
            </div>
        </div>
        )
    }):""
}

  
    <div className="row">
        <div className="col-sm-12 form-group">
            <label className="control-label">Observaciones:</label>
            <label>{datos.observaciones} </label>
        </div>
    </div>

    <h3>
            Documentación:
        </h3>


    <div className="row">
        <div className="col-sm-3 form-group">
            <label className="control-label">Último recibo de sueldo:</label>
            <img src={configSecc.urlBase+"/get_recibo/"+datos.id} style={{width:"100px"}}/>
        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Foto alta temprana AFIP:</label>
            <img src={configSecc.urlBase+"/get_alta_temprana/"+datos.id} style={{width:"100px"}}/>

        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Foto DNI frente:</label>
            <img src={configSecc.urlBase+"/get_dni_frente/"+datos.id} style={{width:"100px"}}/>

        </div>
        <div className="col-sm-3 form-group">
            <label className="control-label">Foto DNI dorso:</label>
            <img src={configSecc.urlBase+"/get_dni_dorso/"+datos.id} style={{width:"100px"}}/>

        </div>
    </div>

    <h3>
            &nbsp;
        </h3>

    <div className="row">
    <div className="col-sm-4 form-group">
       <CanvasDraw brushRadius={1} disabled={true} lazyRadius={0} canvasWidth={300} canvasHeight={150} style={{border:"1px solid black"}} ref={firmaS}/>

           <span className="letraChica">FIRMADO</span>

       
        </div>
        <div className="col-sm-4">&nbsp;</div>
      <span>&nbsp;</span>
        </div>
    </div>

    <h3>
            &nbsp;
        </h3>

   
   


    


    </>);
}

export default Vista;